import React from 'react';

export function useRefreshAgg(initializer: () => (string|number)) {
	const [counter, setCounter] = React.useState(0);
	const refresh = () => setCounter(counter+1);
	const value = initializer() + '-' + counter;
	return {value, refresh};
}
